import React from "react";
import { useHistory } from "react-router-dom";
import { GiftOffer } from "types";
import { SecondaryButton } from "../Common/SecondaryButton";
import { ContentLayout } from "../Layout/ContentLayout";
import { ProductPhotoList } from "./ProductPhotoList";

export const GiftOfferPhotoList = ({ giftOffer }: { giftOffer: GiftOffer }) => {
    const history = useHistory();

    const handleCancel = () => {
        history.push(`/products/giftOffers`);
    };

    return (
        <ContentLayout isWide>
            <ContentLayout.Section
                title="Photos"
                description="You can add up to 10 .jpg, .png and .webp images to each product with a maximum size of 10 MB. The suggested pixel dimensions are 1024 x 1024."
            >
                <ProductPhotoList product={giftOffer} />
            </ContentLayout.Section>

            <ContentLayout.Footer preferenceSidebar>
                <SecondaryButton type="reset" onClick={handleCancel}>
                    Cancel
                </SecondaryButton>
            </ContentLayout.Footer>
        </ContentLayout>
    );
};
